exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd.deleted[data-v-290d8f44] {\n    color: gray;\n    text-decoration: line-through;\n}\n", ""]);

// exports
